export default __webpack_public_path__ + "static/media/trainmagic.bd511658.png";